var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateThemes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H32C32.5523 12 33 11.5523 33 11V4C33 3.44772 32.5523 3 32 3ZM4 0C1.79086 0 0 1.79086 0 4V11C0 13.2091 1.79086 15 4 15H32C34.2091 15 36 13.2091 36 11V9.5H37.5V16.8636H28H18C17.1716 16.8636 16.5 17.5352 16.5 18.3636V22.2908C15.0341 22.8841 14 24.3213 14 26V38C14 40.2091 15.7909 42 18 42C20.2091 42 22 40.2091 22 38V26C22 24.3213 20.9659 22.8841 19.5 22.2908V19.8636H28H39C39.8284 19.8636 40.5 19.1921 40.5 18.3636V8C40.5 7.17157 39.8284 6.5 39 6.5H36V4C36 1.79086 34.2091 0 32 0H4ZM19 38V26C19 25.4477 18.5523 25 18 25C17.4477 25 17 25.4477 17 26V38C17 38.5523 17.4477 39 18 39C18.5523 39 19 38.5523 19 38Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateThemes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateThemes.7f7440b47a5a5edc635049b1cd109837.svg";